const RightHereWaiting = [
	'[Verse 1]',
	'Oceans apart, day after day',
	'And I slowly go insane',
	'I hear your voice on the line',
	"But it doesn't stop the pain",
	'',
	'[Pre-Chorus 1]',
	'If I see you next to never',
	'How can we say forever?',
	'',
	'[Chorus]',
	'Wherever you go',
	'Whatever you do',
	'I will be right here waiting for you',
	'Whatever it takes',
	'Or how my heart breaks',
	'I will be right here waiting for you',
	'',
	'[Verse 2]',
	'I took for granted, all the times',
	'That I thought would last somehow',
	'I hear the laughter, I taste the tears',
	"But I can't get near you now",
	'',
	'[Pre-Chorus 2]',
	"Oh, can't you see it, baby?",
	"You've got me goin' crazy",
	'',
	'[Chorus]',
	'Wherever you go',
	'Whatever you do',
	'I will be right here waiting for you',
	'Whatever it takes',
	'Or how my heart breaks',
	'I will be right here waiting for you',
	'',
	'[Bridge]',
	'I wonder how we can survive',
	'',
	'This romance',
	"But in the end if I'm with you",
	"I'll take the chance",
	'',
	'[Pre-Chorus 3]',
	"Oh, can't you see it, baby?",
	"You've got me goin' crazy",
	'',
	'[Chorus]',
	'Wherever you go',
	'Whatever you do',
	'I will be right here waiting for you',
	'Whatever it takes',
	'Or how my heart breaks',
	'I will be right here waiting for you',
	'',
	'[Outro]',
	'(Waiting for you)',
];

export default RightHereWaiting;
